// Milestone event-log strings — Spanish. Merged in ./messages.ts.

export const gameMilestonesEs = {
  'event.milestone.city.first_founded': 'Nueva ciudad fundada',
  'event.milestone.city.tier_up': 'Una ciudad crece',
  'event.milestone.city.first_capture': 'Primera ciudad capturada',
  'event.milestone.city.capital_captured': 'Capital capturada',
  'event.milestone.hero.first_recruited': 'Primer héroe reclutado',
  'event.milestone.hero.level_milestone': 'Un héroe sube de nivel',
  'event.milestone.doctrine.tier_reached': 'Nivel de doctrina alcanzado',
  'event.milestone.faith.temple_built': 'Primer templo construido',
  'event.milestone.wonder.built': 'Maravilla construida',
  'event.milestone.magic.ritual_completed': 'Ritual completado',
  'event.milestone.diplomacy.peace_signed': 'Paz firmada',
  'event.milestone.battle.decisive': 'Batalla decisiva',
  'event.milestone.era.advanced': 'Una nueva era',
  'event.milestone.victory.achieved': 'Victoria alcanzada',
  'event.milestone.graduation.new_rule': 'Nueva regla desbloqueada',
  'event.milestone.sea.merchant_route': 'Ruta comercial abierta',
  'event.milestone.unknown': 'Hito',
  'event.detail.milestone': 'Jugador {player}',
  'event.detail.milestoneName': 'Jugador {player} — {name}',
  'event.detail.milestoneTier': 'Jugador {player} — ahora una {tier}',
  'event.detail.milestoneLevel': 'Jugador {player} — nivel {level}',
  'event.detail.milestoneEra': 'Jugador {player} — era {era}',
  'event.detail.milestoneWith': 'Jugador {player} — con el jugador {other}',
  'event.milestone.tier.2': 'villa',
  'event.milestone.tier.3': 'ciudad',
  'event.milestone.tier.4': 'metrópolis',
  'event.milestone.tier.5': 'megaciudad',
};
